export const environment = {
  production: true,
  buildId: '3211064224320931',
  configFile: 'config.json',
};
